import styled from "styled-components";
import SideImage from '../../assets/images/the_pepsico_way.png';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
`;

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 600px;
  width: 100%;
  max-width: 800px;

  div.img {
    display: flex;
    flex: 1;
    width: 100%;
    background-position: center;
    background-size: cover;
    background-image: url(${SideImage});
    height: 600px;
  }

  @media (max-width: 500px) {
    div.img {
      display: none;
    }
  }

  div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 350px;
    background-color: white;
    height: 70vh;
    border-top-right-radius: 16px;
    border-bottom-right-radius: 16px;
    padding: 0 50px;

    @media (max-width: 500px) {
      border-radius: 16px;
    }
  }
`;
